import { decode } from "./decode.js";
import { encode } from "./encode.js";
import { from } from "./from.js";
import { fromBytecode } from "./fromBytecode.js";

// Re-export types
export type * from "./MetadataType.js";

// Export all functions
export { decode, encode, from, fromBytecode };
